// extracted by mini-css-extract-plugin
export default {"deletedAppContainer":"style_deletedAppContainer__7ROxl","headerMain":"style_headerMain__owAUC","bodyMain":"style_bodyMain__uBIXw","footerMain":"style_footerMain__5b6Ge"};